import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { JOB_LOG_PAGE_URL, remove } from '@/api/system/job-log';
import { createTableHeaderButton } from '@/component-create/utils/create-table-column';
import { XTable } from '@/components/index';
import { renderJobAddForm } from './add';
import { renderJobEditForm } from './edit';
import { formItems } from './jobLogSearch';
import { jobLogColumn } from './jobLogTable';
import { renderSearchForm } from './search';
import { renderJobTable } from './table';
import { DATE_TIME_RANGE_PICKER_SHORTCUTS } from "@/constant/system/options";
import Moment from 'moment';
import { toast, warningBox } from '@/utils/message';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Job',
  setup(__props) {
    const searchFormRef = ref();
    const tableRef = ref();
    const editRef = ref();
    const addRef = ref();
    const logDialog = ref();
    const deleteLogDialog = ref();
    const xtable = ref();
    const deleteLogType = ref('1');
    const deleteTimes = ref([]);
    const jobLogName = ref('');
    const logId = ref('');
    const searchData = ref({});
    const headerButtons = [createTableHeaderButton('删除', 'danger', 'Delete', () => {
      deleteLogDialog.value.open();
    })];
    onMounted(() => {
      const searchForm = renderSearchForm(searchFormRef.value);
      const edit = renderJobEditForm(editRef.value);
      const add = renderJobAddForm(addRef.value);
      const table = renderJobTable(tableRef.value, searchData, edit, add, jobLogName, logDialog.value);
      searchForm.onSearch = formData => {
        searchData.value = formData;
        table.load(formData);
      };
    });
    function logOpen(id) {
      logId.value = id;
      xtable.value?.load();
    }
    function cancle() {
      deleteLogDialog.value.close();
    }
    function deleteLog() {
      if (!logId.value) {
        return;
      }
      warningBox('此操作无法恢复，是否确认清理？').then(() => {
        let params = {
          logId
        };
        if (deleteLogType.value === '2') {
          params.startTime = Moment(deleteTimes[0]).format('YYYY-MM-DD HH:mm:ss');
          params.endTime = Moment(deleteTimes[1]).format('YYYY-MM-DD HH:mm:ss');
        }
        remove(params).then(() => {
          toast.success('清理成功');
        });
      });
    }
    return (_ctx, _cache) => {
      const _component_XSearchForm = _resolveComponent("XSearchForm");
      const _component_XCommonDialog = _resolveComponent("XCommonDialog");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_button = _resolveComponent("el-button");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "searchFormRef",
          ref: searchFormRef
        }, null, 512), _createElementVNode("div", {
          style: {
            "height": "100%"
          },
          ref_key: "tableRef",
          ref: tableRef
        }, null, 512), _createElementVNode("div", {
          ref_key: "editRef",
          ref: editRef
        }, null, 512), _createElementVNode("div", {
          ref_key: "addRef",
          ref: addRef
        }, null, 512), _createVNode(_component_XCommonDialog, {
          ref_key: "logDialog",
          ref: logDialog,
          title: '任务日志 - ' + _unref(jobLogName),
          onOpen: logOpen,
          width: "70%"
        }, {
          default: _withCtx(() => [_createVNode(_component_XSearchForm, {
            items: _unref(formItems)
          }, null, 8, ["items"]), _createVNode(_unref(XTable), {
            ref_key: "xtable",
            ref: xtable,
            requestData: {
              jobId: _unref(logId)
            },
            url: _unref(JOB_LOG_PAGE_URL),
            column: _unref(jobLogColumn),
            headerButtons: headerButtons
          }, null, 8, ["requestData", "url", "column"])]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_XCommonDialog, {
          ref_key: "deleteLogDialog",
          ref: deleteLogDialog,
          title: "日志清理"
        }, {
          footer: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            onClick: cancle
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "danger",
            onClick: deleteLog
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("删除")])),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: _unref(deleteLogType),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(deleteLogType) ? deleteLogType.value = $event : null),
            class: "ml-4"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: "1",
              size: "large"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("全部")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: "2",
              size: "large"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("span", {
                style: {
                  "padding-right": "10px"
                }
              }, "指定时间", -1)), _unref(deleteLogType) === '2' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 0,
                modelValue: _unref(deleteTimes),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(deleteTimes) ? deleteTimes.value = $event : null),
                type: "datetimerange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                placeholder: "执行时间",
                shortcuts: _unref(DATE_TIME_RANGE_PICKER_SHORTCUTS)
              }, null, 8, ["modelValue", "shortcuts"])) : _createCommentVNode("", true)])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 512)]),
        _: 1
      });
    };
  }
});